import React from 'react';
import { TextField } from '@mui/material';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import {
  LocalizationProvider,
  DateTimePicker,
  DatePicker,
  TimePicker,
} from '@mui/x-date-pickers';
import moment from 'moment';
import { useSelector } from 'react-redux';

const DEFAULT_POPPER_Z_INDEX = 10700;

const CustomDateTimePicker = ({
  label,
  value,
  onChange,
  disabled = false,
  isValidDate,
  placeholder = 'Select',
  sx,
  ampm = false,
  mode = 'datetime',
  popperZIndex = DEFAULT_POPPER_Z_INDEX,
  ...props
}) => {
  const isDarkMode = useSelector((state) => state.appSettings?.appDarkMode);
  const { slotProps: slotPropsProp, ...restProps } = props;

  const mergedSlotProps = {
    ...slotPropsProp,
    popper: {
      ...(slotPropsProp?.popper || {}),
      sx: {
        zIndex: popperZIndex,
        ...(typeof slotPropsProp?.popper?.sx === 'object' ? slotPropsProp.popper.sx : {}),
      },
    },
    desktopPaper: {
      ...(slotPropsProp?.desktopPaper || {}),
      sx: {
        zIndex: popperZIndex,
        ...(typeof slotPropsProp?.desktopPaper?.sx === 'object' ? slotPropsProp.desktopPaper.sx : {}),
      },
    },
  };

  const commonProps = {
    label,
    value: value ? moment(value) : null,
    onChange: (newValue) => onChange(newValue),
    disabled,
    shouldDisableDate: isValidDate,
    ampm: false,
    slotProps: mergedSlotProps,
    renderInput: (params) => (
      <TextField
        {...params}
        placeholder={placeholder}
        sx={{
          ...sx,
          '& .MuiInputBase-root': {
            height: '44px',
            borderRadius: '10px',
            border: isDarkMode ? '1px solid #404040' : '1px solid #D9D9D9',
            backgroundColor: isDarkMode ? '#2d3436' : '#F9F9F9',
            color: isDarkMode ? '#ffffff' : '#495057',
          },
          '& .MuiInputBase-input': {
            padding: '0 14px',
            color: isDarkMode ? '#ffffff' : '#495057',
          },
          '& .MuiSvgIcon-root': {
            color: isDarkMode ? '#adb5bd' : '#6c757d',
          },
          '& .MuiInputLabel-root': {
            color: isDarkMode ? '#adb5bd' : '#6c757d',
          },
        }}
      />
    ),
    ...restProps,
  };

  const getPickerComponent = () => {
    switch (mode) {
      case 'date':
        return <DatePicker {...commonProps} />;
      case 'time':
        return <TimePicker {...commonProps} />;
      default:
        return <DateTimePicker {...commonProps} />;
    }
  };

  return <LocalizationProvider dateAdapter={AdapterMoment}>{getPickerComponent()}</LocalizationProvider>;
};

export default CustomDateTimePicker;